var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIPhoneIcons = function SvgIPhoneIcons(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3685 0C19.5108 1.85781 18.9233 3.6979 17.7307 5.12951C16.5737 6.56853 14.8206 7.39741 12.9743 7.3784C12.8568 5.57408 13.4615 3.79709 14.655 2.43881C15.8636 1.06213 17.5466 0.191359 19.3685 0ZM25.2077 10.916C23.0838 12.2218 21.7769 14.5245 21.7448 17.0175C21.7478 19.838 23.4369 22.3834 26.0346 23.4822C25.535 25.1051 24.7819 26.6389 23.8033 28.0266C22.489 29.9927 21.1109 31.9135 18.9237 31.949C17.8835 31.973 17.1814 31.6738 16.4497 31.3621C15.6865 31.037 14.8912 30.6982 13.6467 30.6982C12.3269 30.6982 11.496 31.0479 10.6947 31.3852C10.0021 31.6766 9.33167 31.9588 8.38678 31.998C6.30381 32.0751 4.71194 29.8996 3.34985 27.952C0.62744 23.9746 -1.49241 16.7431 1.34955 11.8225C2.68412 9.42434 5.17944 7.90254 7.92254 7.81391C9.10391 7.78961 10.2375 8.24494 11.2314 8.64415C11.9914 8.94944 12.6698 9.22191 13.2253 9.22191C13.7136 9.22191 14.373 8.9602 15.1415 8.6552C16.352 8.17474 17.8333 7.58686 19.3427 7.74531C21.6882 7.81869 23.8618 8.99376 25.2077 10.916Z",
    fill: "#040721"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIPhoneIcons);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iPhone-icons.13e08fcf99c263763727007f0a8c8761.svg";